import BackboneElement from './BackboneElement';
import Reference from './types/Reference';

import merge from 'lodash/merge';

export default class ProvenanceEntity extends BackboneElement {
    static __className = 'ProvenanceEntity';

    __objectStructure = {
        role: String, // derivation | revision | quotation | source | removal
        what: Reference, // may be a local reference to a contained snapshot
    };

    constructor(constructJson, className = 'ProvenanceEntity') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
